export default {
    CMD_OMNIKEY: "omnikey",
    CMD_MDE: "mde",
    CMD_LUMIDIGM: "lumidigm",
    CMD_MORPHO: "morpho",
    CMD_CONTROLID: "controlid",
    CMD_HIKVISION: "hikvision",
    CMD_SUPREMA: "suprema",
    CMD_PRINT: "print",
    CMD_CAMERA: "camera",
    CMD_EXTENSION: "extension",
    CMD_NITGEN: "nitgen",
    CMD_VALIDATE: "validatePlugin",
    CMD_VALIDATE_ANY: "any"
};
